<template>
    <div class="application-thumb__wrapper">
        <div class="application-thumb">
            <div class="application-thumb__content">
                <div class="application-thumb__icon" :class="applicationTypeClass">
                    <div class="application-thumb__metadata" :class="applicationTypeClass">
                        <slot name="metadata"></slot>
                    </div>
                    <application-logo :version="currentVersion"></application-logo>
                </div>
            </div>
            <div class="application-thumb__footer">
                {{ application.name[currentLocale] }}
            </div>
        </div>
    </div>
</template>

<script>
import {store} from "atom";
import ApplicationLogo from "./ApplicationLogo";
const {createNamespacedHelpers} = store;
const {mapGetters} = createNamespacedHelpers("arcman");
export default {
    name: "application-thumb",
    props: {
        application: {type: Object, required: true},
    },
    components: {
        ApplicationLogo,
    },
    computed: {
        ...mapGetters(["currentLocale"]),
        currentVersion() {
            return this.application.versions[this.application.currentVersionIndex];
        },
        applicationTypeClass() {
            return `application-thumb__icon_${this.application.type.split(" ").join("-")}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.application-thumb__wrapper::v-deep {
    .application-thumb {
        @apply flex flex-col justify-end rounded shadow m-1 w-32;
        background-color: $background-application-color;
        font-size: $font-small;
        min-height: 6rem;
        border: 1px solid $border-card-color;
    }

    .application-thumb__content {
        @apply flex justify-center p-1;
    }

    .application-thumb__icon {
        @apply relative flex items-center justify-center rounded;
        max-width: 3.5rem;
        height: 3.5rem;
    }

    .application-thumb__icon_binary {
        background-color: $background-application-binary-card-header-color;
    }

    .application-thumb__icon_webapp {
        background-color: $background-application-webapp-card-header-color;
    }

    .application-thumb__icon_remote-html {
        background-color: $background-application-remote-html-card-header-color;
    }

    .application-thumb__metadata {
        @apply absolute top-0 left-0 text-white rounded-full;
        transform: translate(-50%, -20%);
    }

    .application-thumb__footer {
        @apply text-center font-bold p-1 truncate;
    }
}
</style>
